import { Space } from '@/modules/defines/interface';
import { body1, body2, palette } from '@/modules/defines/styles';
import getCategoryIcon from '@/utils/function/getCategoryIcon';
import search_bold from '@/assets/icon/search-bold.svg';
import * as hangul from 'hangul-js';
import styled from 'styled-components';

interface SpaceFilterListProps {
  filterList: Space[] | undefined;
  value: string;
  onClick: (value: Space) => void;
  isSearchMode: boolean;
}

const SpaceFilterList = ({
  filterList,
  onClick,
  value,
  isSearchMode,
}: SpaceFilterListProps) => {
  if (!filterList) return null;
  const zoneType = [
    {
      type: 'raon',
      title: '라온존',
    },
    {
      type: 'atti',
      title: '아띠존',
    },
    {
      type: '-',
      title: '-',
    },
  ];

  const findKorName = (type: string) => {
    if (!type) return '정보 없음';
    return zoneType.find((zone) => zone.type === type)?.title;
  };

  const filteredSpaces =
    filterList.filter((space) => {
      return hangul.search(space.title, value) >= 0;
    }) || filterList;

  return (
    <SearchList $isSearchMode={isSearchMode}>
      <ul>
        {filteredSpaces && filteredSpaces.length > 0 ? (
          filteredSpaces.map((item, index) => (
            <SearchListItem
              key={index}
              onClick={() => {
                onClick({
                  ...item,
                });
              }}
            >
              <img width={20} height={20} src={search_bold} alt="search_mode" />
              <SearchInfoItem>
                <Spacing $width="1.875rem" $margin="0 0.25rem 0 0">
                  {item.floor === '-1' ? 'B1F' : `${item.floor}F`}
                </Spacing>
                <Spacing $margin="0 0.5rem 0 0">
                  {findKorName(item.type)}
                </Spacing>
                {item.title.split(value).map((word, index) => (
                  <SearchInfoTitle key={index}>
                    {word}
                    {index !== item.title.split(value).length - 1 && (
                      <Em>{value}</Em>
                    )}
                  </SearchInfoTitle>
                ))}
              </SearchInfoItem>
              <img
                width={24}
                height={24}
                src={getCategoryIcon(item.category)}
                alt="category"
              />
            </SearchListItem>
          ))
        ) : (
          <NoResult>검색 결과가 없습니다</NoResult>
        )}
      </ul>
    </SearchList>
  );
};

const SearchList = styled.ul<{
  $isSearchMode: boolean;
}>`
  display: ${(props) => (props.$isSearchMode ? 'block' : 'none')};
  background: white;
  position: absolute;
  padding: 1rem 1rem 15rem 1rem;
  width: min(100%, 496px);
  height: 100%;
  overflow-y: auto;
  z-index: 999;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    padding: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${palette.gray300};
    border-radius: 10px;
    border: 2px solid transparent;
    background-clip: content-box;
  }
`;

const SearchListItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
`;
const SearchInfoItem = styled.div`
  margin: 0 0.5rem 0 1.25rem;
  display: flex;
  color: ${palette.gray700};
  ${body2};
  align-items: center;
  width: 100%;
`;

const Spacing = styled.span<{ $margin: string; $width?: string }>`
  margin: ${(props) => props.$margin};
  width: ${(props) => props.$width};
`;
const Em = styled.em`
  ${body1};
  color: ${palette.primaryRed500};
`;
const SearchInfoTitle = styled.span`
  ${body1};
  display: flex;
`;

const NoResult = styled.div`
  color: ${palette.gray700};
  ${body2};
  height: 50dvh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default SpaceFilterList;
